import {__} from "@wordpress/i18n";
import {MessageProps} from "../types/messages";

const STORAGE_KEY = 'chat-history';

function shouldClear(history: MessageProps[]): boolean {
    if (!history.length)
        return false;

    const last = new Date(history[history.length - 1].timestamp ?? 0);
    const now = new Date();

    const isDifferentDay =
        now.getFullYear() !== last.getFullYear() ||
        now.getMonth() !== last.getMonth() ||
        now.getDate() !== last.getDate();

    const diffHours =
        (now.getTime() - last.getTime()) / (1000 * 60 * 60);

    return isDifferentDay && diffHours >= 3;
}

export const storage = {
    load(): MessageProps[] {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);

            if (!raw) return [];

            const messages: MessageProps[] = JSON.parse(raw);

            if (shouldClear(messages)) {
                this.clear();
                return [];
            }

            return messages;
        } catch {
            this.clear();
            return [];
        }
    },

    save(messages: MessageProps[]) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
    },

    add(message: MessageProps) {
        const history = this.load();

        history.push({
            ...message,
            timestamp: Date.now(),
        });

        this.save(history);
    },

    clear() {
        localStorage.removeItem(STORAGE_KEY);
    },
};
